import { useContext } from 'react';
import { useAppSelector, VRIAppStateType } from '../Redux';
import { SocketContext } from './SocketContext';
import { useGuestContext } from './GuestContext';

export const useTwilioTokenContext = () => {
  const isLoggedIn = useAppSelector((state: VRIAppStateType) => state.auth.isLoggedIn);

  const socketCtx = useContext(SocketContext);
  const guestCtx = useGuestContext();

  return isLoggedIn ? socketCtx : guestCtx;
};
